import { Api } from '@/utils/Api'
import setEntities from '@/utils/SetEntities'
import UrlStore from '@/utils/UrlStore'
import { normalize, schema } from 'normalizr'
import Vue from 'vue'

export const ROOMS_LOAD = 'ROOMS_LOAD'
export const ROOM_LOAD = 'ROOM_LOAD'
export const ROOM_CREATE = 'ROOM_CREATE'
export const ROOM_UPDATE = 'ROOM_UPDATE'
export const ROOM_DESTROY = 'ROOM_DESTROY'
export const ROOM_STATE_UPDATE = 'ROOM_STATE_UPDATE'

const roomsApi = new Api(UrlStore.ROOMS)
const roomSchema = new schema.Entity('rooms')

export const extractRooms = (context, points) => {
  let rooms = []
  points.forEach((point) => {
    if (point.room) {
      rooms.push(point.room)
      point.room = point.room.id
    }
  })
  if (rooms.length) {
    context.commit('room/' + ROOMS_LOAD, { items: rooms }, { root: true })
  }
}

export default {
  namespaced: true,
  state: {
    roomsLoaded: false,
    roomsList: [],
    entities: {
      rooms: {}
    }
  },
  getters: {
    rooms(state) {
      return state.roomsList.map((bId) => state.entities.rooms[bId])
    },
    getRoom: (state) => (roomId) => state.entities.rooms[roomId] || null
  },
  mutations: {
    [ROOMS_LOAD](state, payload) {
      let normData = normalize(payload.items, [roomSchema])
      state.roomsList = normData.result
      setEntities(state, normData)
    },
    [ROOM_LOAD](state, payload) {
      let normData = normalize(payload, roomSchema)
      setEntities(state, normData)
    },
    [ROOM_CREATE](state, room) {
      state.roomsList.push(room.id)
      Vue.set(state.entities.rooms, room.id, room)
    },
    [ROOM_UPDATE](state, room) {
      if (room.id && state.entities.rooms[room.id]) {
        state.entities.rooms[room.id] = Object.assign({}, state.entities.rooms[room.id], room)
      }
    },
    [ROOM_DESTROY](state, room) {
      let num = state.roomsList.findIndex((cId) => cId === room.id)
      if (num !== -1) {
        state.roomsList.splice(num, 1)
        delete state.entities.rooms[room.id]
      }
    },
    [ROOM_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    roomsLoad({ commit }, config = {}) {
      roomsApi.getAll(config).then((r) => {
        commit(ROOMS_LOAD, r.data)
        commit(ROOM_STATE_UPDATE, { roomsLoaded: true })
      })
    },
    roomLoad({ commit }, config) {
      roomsApi.get({ id: config.id, config: config }).then((r) => {
        commit(ROOM_LOAD, r.data)
      })
    },
    roomSave({ commit, getters }, { room, config = {} }) {
      if (!room.id) throw new Error('Room id is not present in `roomSave`!')
      commit(getters.getRoom(room.id) ? ROOM_UPDATE : ROOM_CREATE, room)
      let roomUpdated = getters.getRoom(room.id)

      return roomsApi.save(roomUpdated, config).then((r) => {
        if (r._isNew) {
          commit(ROOM_DESTROY, roomUpdated) // local
          commit(ROOM_CREATE, r.data)
          if (r.data.point_id) {
            commit(`point/POINT_UPDATE`, { id: r.data.point_id, room: r.data.id }, { root: true })
          }
        } else {
          commit(ROOM_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    roomDestroy({ commit }, room) {
      roomsApi.destroy({ id: room.id }).then(() => {
        commit(ROOM_DESTROY, room)
      })
    }
  }
}
